"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnerStatusManagementSection = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var demo_auth_context_1 = require("../../auth/demo-auth-context");
var ai_hub_rbac_api_service_1 = require("../../services/ai-hub-rbac-api.service");
var ai_hub_readiness_api_service_1 = __importDefault(require("../../services/ai-hub-readiness-api.service"));
var utils_1 = require("../../utils");
var DropDownWithSearch_1 = require("../DropDownWithSearch");
var NOT_ASSIGNED_OPTION = 'Not assigned';
var STATUS_OPTIONS = ['In progress', 'Ready'];
var ELEMENT_SCOPE_PREFIX = 'elements.';
var READINESS_UPDATED_EVENT = 'ws-ai-hub:readiness-updated';
var toComparableElementValue = function (rawId) {
    var normalized = utils_1.normalizeElementId(rawId);
    var separatorIndex = normalized.indexOf(':');
    return separatorIndex >= 0 ? normalized.slice(separatorIndex + 1) : normalized;
};
var hasPermissionForElement = function (permissions, elementId) {
    if (!elementId) {
        return false;
    }
    var normalizedElementId = utils_1.normalizeElementId(elementId);
    var comparableElementValue = toComparableElementValue(elementId);
    return permissions.some(function (permission) {
        var normalizedPermission = permission.trim().toLowerCase();
        var normalizedScope = normalizedPermission.startsWith(ELEMENT_SCOPE_PREFIX)
            ? normalizedPermission.slice(ELEMENT_SCOPE_PREFIX.length)
            : normalizedPermission;
        var firstDot = normalizedScope.indexOf('.');
        if (firstDot < 0) {
            return false;
        }
        var category = normalizedScope.slice(0, firstDot);
        var scopeValue = normalizedScope.slice(firstDot + 1);
        if (scopeValue === '*') {
            return (normalizedElementId.indexOf(category + ":") === 0 ||
                normalizedElementId === category ||
                normalizedElementId.indexOf(category + ".") === 0);
        }
        var normalizedScopeId = utils_1.normalizeElementId(normalizedScope);
        if (normalizedScopeId === normalizedElementId) {
            return true;
        }
        return toComparableElementValue(normalizedScope) === comparableElementValue;
    });
};
var shouldShowStatusForElement = function (elementId) {
    if (!elementId) {
        return false;
    }
    var normalizedElementId = utils_1.normalizeElementId(elementId);
    return normalizedElementId.indexOf('data:') === 0 || normalizedElementId.indexOf('tech:') === 0;
};
var getElementOwnerScope = function (elementId) {
    if (!elementId) {
        return null;
    }
    var normalizedElementId = utils_1.normalizeElementId(elementId);
    var separatorIndex = normalizedElementId.indexOf(':');
    if (separatorIndex <= 0) {
        return null;
    }
    var category = normalizedElementId.slice(0, separatorIndex);
    return "" + ELEMENT_SCOPE_PREFIX + category + "." + normalizedElementId;
};
var statusFromElementReadiness = function (elementIsReady, fallback) {
    if (elementIsReady === true) {
        return 'Ready';
    }
    if (elementIsReady === false) {
        return 'In progress';
    }
    return fallback || STATUS_OPTIONS[0];
};
var haveSameItems = function (left, right) {
    if (left.length !== right.length) {
        return false;
    }
    return left.every(function (value) { return right.indexOf(value) >= 0; });
};
exports.OwnerStatusManagementSection = function (_a) {
    var elementId = _a.elementId, elementIsReady = _a.elementIsReady, useCaseId = _a.useCaseId, workflowId = _a.workflowId, owner = _a.owner, owners = _a.owners, role = _a.role, initialStatus = _a.initialStatus, registerSaveHandler = _a.registerSaveHandler, onSaveStateChange = _a.onSaveStateChange;
    var activeUser = demo_auth_context_1.useDemoAuth().activeUser;
    var _b = react_1.useState([]), ownerUsers = _b[0], setOwnerUsers = _b[1];
    var _c = react_1.useState(false), isSavingOwners = _c[0], setIsSavingOwners = _c[1];
    var _d = react_1.useState(null), ownersSaveError = _d[0], setOwnersSaveError = _d[1];
    var _e = react_1.useState(false), hasUserInteraction = _e[0], setHasUserInteraction = _e[1];
    var effectiveRole = role !== null && role !== void 0 ? role : activeUser.role;
    var shouldShowOwnerStatusSection = effectiveRole === 'admin' || effectiveRole === 'owner' || effectiveRole === 'group-owner';
    var effectiveWorkflowId = workflowId ? workflowId.trim() : '';
    react_1.useEffect(function () {
        var cancelled = false;
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var users;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ai_hub_rbac_api_service_1.fetchUsersByRole(['owner'])];
                    case 1:
                        users = _a.sent();
                        if (!cancelled) {
                            setOwnerUsers(users);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        void run();
        return function () {
            cancelled = true;
        };
    }, []);
    if (!shouldShowOwnerStatusSection) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var currentUserHasElementPermission = hasPermissionForElement(activeUser.permissions, elementId);
    var canEditOwner = effectiveRole === 'admin' ||
        (effectiveRole === 'group-owner' && currentUserHasElementPermission);
    var canEditStatus = effectiveRole === 'admin' ||
        (effectiveRole === 'group-owner' && currentUserHasElementPermission) ||
        (effectiveRole === 'owner' && currentUserHasElementPermission);
    var shouldShowStatusField = shouldShowStatusForElement(elementId);
    var ownerScope = getElementOwnerScope(elementId);
    var initialElementStatus = statusFromElementReadiness(elementIsReady, initialStatus);
    var sectionTitle = shouldShowStatusField ? 'Owner and Status Management' : 'Owner Management';
    var ownerOptions = react_1.useMemo(function () { return __spreadArrays([
        { key: NOT_ASSIGNED_OPTION, text: NOT_ASSIGNED_OPTION }
    ], ownerUsers.map(function (user) { return ({ key: user.id, text: user.displayName }); })); }, [ownerUsers]);
    var initialOwnerIds = react_1.useMemo(function () {
        if (elementId) {
            var ownersFromRbac = ownerUsers
                .filter(function (user) { return hasPermissionForElement(user.permissions, elementId); })
                .map(function (user) { return user.id; });
            if (ownersFromRbac.length > 0) {
                return ownersFromRbac;
            }
            if (effectiveRole === 'owner' && currentUserHasElementPermission) {
                return [activeUser.id];
            }
        }
        var ownerNames = owners && owners.length > 0 ? owners : owner ? [owner] : [];
        if (ownerNames.length === 0) {
            return [NOT_ASSIGNED_OPTION];
        }
        var names = ownerNames
            .map(function (name) { return name.trim().toLowerCase(); })
            .filter(function (name) { return name.length > 0; });
        var mappedIds = ownerUsers
            .filter(function (user) { return names.indexOf(user.displayName.trim().toLowerCase()) >= 0; })
            .map(function (user) { return user.id; });
        return mappedIds.length > 0 ? mappedIds : [NOT_ASSIGNED_OPTION];
    }, [
        activeUser.id,
        currentUserHasElementPermission,
        effectiveRole,
        elementId,
        owner,
        ownerUsers,
        owners,
    ]);
    var _f = react_1.useState(initialOwnerIds), selectedOwnerIds = _f[0], setSelectedOwnerIds = _f[1];
    var _g = react_1.useState(initialElementStatus), persistedStatus = _g[0], setPersistedStatus = _g[1];
    var _h = react_1.useState(initialElementStatus), selectedStatus = _h[0], setSelectedStatus = _h[1];
    var persistedOwnerIds = react_1.useMemo(function () {
        if (!ownerScope) {
            return [];
        }
        return ownerUsers
            .filter(function (user) { return hasPermissionForElement(user.permissions, elementId); })
            .map(function (user) { return user.id; });
    }, [elementId, ownerScope, ownerUsers]);
    var selectedOwnerIdsWithoutPlaceholder = react_1.useMemo(function () { return selectedOwnerIds.filter(function (ownerId) { return ownerId !== NOT_ASSIGNED_OPTION; }); }, [selectedOwnerIds]);
    var ownerIdsToGrant = react_1.useMemo(function () {
        if (!ownerScope) {
            return [];
        }
        return selectedOwnerIdsWithoutPlaceholder.filter(function (ownerId) { return persistedOwnerIds.indexOf(ownerId) < 0; });
    }, [ownerScope, persistedOwnerIds, selectedOwnerIdsWithoutPlaceholder]);
    var ownerIdsToRevoke = react_1.useMemo(function () {
        if (!ownerScope) {
            return [];
        }
        return persistedOwnerIds.filter(function (ownerId) { return selectedOwnerIdsWithoutPlaceholder.indexOf(ownerId) < 0; });
    }, [ownerScope, persistedOwnerIds, selectedOwnerIdsWithoutPlaceholder]);
    var canPersistReadiness = shouldShowStatusField && Boolean(elementId);
    var readinessChanged = canPersistReadiness && selectedStatus !== persistedStatus;
    var ownerChanged = canEditOwner && (ownerIdsToGrant.length > 0 || ownerIdsToRevoke.length > 0);
    var hasChanges = ownerChanged || readinessChanged;
    var hasChangesForSave = hasUserInteraction && hasChanges;
    react_1.useEffect(function () {
        setHasUserInteraction(false);
    }, [elementId, useCaseId, workflowId]);
    react_1.useEffect(function () {
        setSelectedOwnerIds(initialOwnerIds);
    }, [initialOwnerIds]);
    react_1.useEffect(function () {
        var nextStatus = statusFromElementReadiness(elementIsReady, initialStatus);
        setPersistedStatus(nextStatus);
        setSelectedStatus(nextStatus);
    }, [elementId, elementIsReady, initialStatus, shouldShowStatusField]);
    react_1.useEffect(function () {
        if (!registerSaveHandler) {
            return;
        }
        var saveOwnersAndStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            var refreshedOwners, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!hasChangesForSave) {
                            setOwnersSaveError(null);
                            return [2 /*return*/, true];
                        }
                        setIsSavingOwners(true);
                        setOwnersSaveError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 11, , 12]);
                        if (!(ownerScope && ownerChanged)) return [3 /*break*/, 5];
                        return [4 /*yield*/, Promise.all(ownerIdsToGrant.map(function (ownerId) { return ai_hub_rbac_api_service_1.addUserScope(ownerId, ownerScope); }))];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(ownerIdsToRevoke.map(function (ownerId) { return ai_hub_rbac_api_service_1.removeUserScope(ownerId, ownerScope); }))];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, ai_hub_rbac_api_service_1.fetchUsersByRole(['owner'])];
                    case 4:
                        refreshedOwners = _a.sent();
                        setOwnerUsers(refreshedOwners);
                        _a.label = 5;
                    case 5:
                        if (!(canPersistReadiness && readinessChanged)) return [3 /*break*/, 10];
                        if (!(selectedStatus === 'Ready')) return [3 /*break*/, 7];
                        return [4 /*yield*/, ai_hub_readiness_api_service_1.default.markElementReady(elementId)];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, ai_hub_readiness_api_service_1.default.markElementUnready(elementId)];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        setPersistedStatus(selectedStatus);
                        window.dispatchEvent(new CustomEvent(READINESS_UPDATED_EVENT, {
                            detail: {
                                useCaseId: useCaseId,
                                workflowId: effectiveWorkflowId,
                            },
                        }));
                        _a.label = 10;
                    case 10:
                        setIsSavingOwners(false);
                        return [2 /*return*/, true];
                    case 11:
                        error_1 = _a.sent();
                        setOwnersSaveError(error_1.message || 'Could not save owner changes. Try again.');
                        setIsSavingOwners(false);
                        return [2 /*return*/, false];
                    case 12: return [2 /*return*/];
                }
            });
        }); };
        registerSaveHandler(saveOwnersAndStatus);
        return function () {
            registerSaveHandler(null);
        };
    }, [
        effectiveWorkflowId,
        elementId,
        ownerScope,
        ownerChanged,
        ownerUsers,
        registerSaveHandler,
        selectedOwnerIds,
        persistedStatus,
        selectedStatus,
        shouldShowStatusField,
        useCaseId,
        hasChangesForSave,
    ]);
    react_1.useEffect(function () {
        if (!onSaveStateChange) {
            return;
        }
        onSaveStateChange({ hasChanges: hasChangesForSave, isSaving: isSavingOwners });
    }, [hasChangesForSave, isSavingOwners, onSaveStateChange]);
    return (react_1.default.createElement("section", { className: "ws-entity-popup-section ws-entity-popup-section--owner", "data-section-id": "owner-status" },
        react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" }, sectionTitle),
        react_1.default.createElement("div", { className: "ws-entity-popup-section-body-columns" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "ws-entity-popup-field-label" }, "Owner"),
                react_1.default.createElement(DropDownWithSearch_1.DropDownWithSearch, { ariaLabel: "Owner", selectedKey: selectedOwnerIds, multiSelect: true, options: ownerOptions, disabled: !canEditOwner || isSavingOwners, onChange: function (_event, option) {
                        if (!option) {
                            return;
                        }
                        var ownerId = option.key;
                        setSelectedOwnerIds(function (current) {
                            var next;
                            if (ownerId === NOT_ASSIGNED_OPTION && option.selected) {
                                next = [NOT_ASSIGNED_OPTION];
                            }
                            else {
                                var withoutNotAssigned = current.filter(function (value) { return value !== NOT_ASSIGNED_OPTION; });
                                if (option.selected) {
                                    next = withoutNotAssigned.concat(ownerId);
                                }
                                else {
                                    var filtered = withoutNotAssigned.filter(function (value) { return value !== ownerId; });
                                    next = filtered.length > 0 ? filtered : [NOT_ASSIGNED_OPTION];
                                }
                            }
                            if (!haveSameItems(current, next)) {
                                setHasUserInteraction(true);
                            }
                            return next;
                        });
                    } }),
                ownersSaveError ? (react_1.default.createElement("div", { className: "ws-entity-popup-field-help", style: { color: '#dc2626', marginTop: 6 } }, ownersSaveError)) : null),
            shouldShowStatusField && (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "ws-entity-popup-field-label" }, "Status"),
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { ariaLabel: "Status", selectedKey: selectedStatus, options: STATUS_OPTIONS.map(function (status) { return ({ key: status, text: status }); }), disabled: !canEditStatus || isSavingOwners, onChange: function (_event, option) {
                        if (option) {
                            var nextStatus = option.key;
                            if (nextStatus !== selectedStatus) {
                                setHasUserInteraction(true);
                                setSelectedStatus(nextStatus);
                            }
                        }
                    } }))))));
};
